<div class="card py-3">
    <signature-pad #signature [options]="signaturePadOptions" (drawEnd)="drawComplete($event)"></signature-pad>
    <div class="d-flex pt-2 mx-auto" style="width: 350px">
        <small class="text-muted d-block p-0 m-0">Sign here</small>
        <button type="button" class="btn-sm ms-auto btn btn-gray" (click)="clear()">Clear</button>
    </div>
</div>
